import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import { selectCard, toggleCreditsPayment, setOnCreditsPayment, setOffCreditsPayment } from '../../redux/actions';
import { Triangle, getCardBrandIcon, objectIsEmpty } from '../../utils';
import Checkbox from '../../components/Checkbox/index';

import { CardContainer, CardValue, CardItem } from './styles';

const DropdownIndicator = props => (
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <Triangle width={12} height={9} color='#1EB6FF' />
    </components.DropdownIndicator>
  )
);

const SingleValue = ({ children, data, selectProps: { yourCreditsToPay, usingCredits, isCreditsEnough, noCredits, cardOnly }  }) => {
  const icon = getCardBrandIcon(data.brand);
  const shouldCardInfoAppear = !isCreditsEnough || !usingCredits;
  if(data.value === 'credits') return (
    <CardValue checked={usingCredits}>
      <b>
        {`$${yourCreditsToPay.toFixed(2)} `}
      </b>
      your credit
    </CardValue>
  )
  return (
    <CardValue smallCred={shouldCardInfoAppear}>
      {shouldCardInfoAppear && icon}
      <div>
        {shouldCardInfoAppear && children}
        {usingCredits && !noCredits &&  !cardOnly && (
          <span>
            ${yourCreditsToPay.toFixed(2)} of your credit balance
          </span>
        )}
      </div>
    </CardValue>
)};

SingleValue.propTypes = {
  children: PropTypes.node,
  data: PropTypes.instanceOf(Object),
  selectProps: PropTypes.instanceOf(Object),
};

const getCustomOption = ({ isFocused, isSelected, children, innerProps, data, selectProps: { usingCredits, userData, isCreditsEnough } }) => {
  const checkedCard = isCreditsEnough && usingCredits ? false : isSelected;
  return(
    <CardItem isFocused={(!isCreditsEnough && isFocused)} isSelected={!isCreditsEnough && isSelected} type="button" {...innerProps}>
      { data.value === 'credits' && userData && (
        <Checkbox blue checked={usingCredits} name='credits' radio={isCreditsEnough} />
      ) || userData && (
        <Checkbox blue checked={checkedCard} name='card' radio />
      )}
      {getCardBrandIcon(data.brand)}{children}
    </CardItem>
)};

getCustomOption.propTypes = {
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  children: PropTypes.node,
  innerProps: PropTypes.instanceOf(Object),
  data: PropTypes.instanceOf(Object),
  selectProps: PropTypes.instanceOf(Object),
};

const mapStateToProps = state => ({
  cardsData: state.user.cards,
  guests: state.userPreferences.guests,
  promo: state.promo,
  userPreferencesDate: state.userPreferences.date,
  payingWith: state.userPreferences.payingWith,
  maxGuests: state.userProduct.product.maxGuests,
  price: state.userProduct.product.price.total,
  isCreditsUsed: state.payment.usingCredits,
  tax: state.userProduct.product.price.tax,
  type: state.userProduct.product.type,
  userData: state.user.userData,
  usingCredits: state.payment.usingCredits,
  changeCheckinDateBool: state.bookingManagement.changeCheckingDate.isPaying,
  changeCheckinDateDif: state.bookingManagement.changeCheckingDate.diff,
  changeCheckinDateTax: state.bookingManagement.changeCheckingDate.tax,
  changeCheckinDate: state.bookingManagement.changeCheckingDate.newDate
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleCardSelect: selectCard,
  toggleCredits: toggleCreditsPayment,
  setOnCredits: setOnCreditsPayment,
  setOffCredits: setOffCreditsPayment,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class CardSelect extends Component {
  static propTypes = {
    cardsData: PropTypes.instanceOf(Object),
    handleCardSelect: PropTypes.func,
    toggleCredits: PropTypes.func,
    setOnCredits: PropTypes.func,
    setOffCredits: PropTypes.func,
    payingWith: PropTypes.instanceOf(Object),
    style: PropTypes.instanceOf(Object),
    cardOnly: PropTypes.bool,
    noCredits: PropTypes.bool,
    price: PropTypes.number,
    userData: PropTypes.instanceOf(Object),
    promo: PropTypes.instanceOf(Object),
    maxGuests: PropTypes.number,
    guests: PropTypes.number,
    usingCredits: PropTypes.bool,
    tax: PropTypes.number,
  };

  componentDidMount() {
    const { userData, setOnCredits } = this.props;

    if (userData && userData.credits.total > 0) {
      setOnCredits();
    }
  };

  componentDidUpdate(prevState) {
    const { userData, setOnCredits } = this.props;
    const { userData: oldUserData } = prevState;

    if ((oldUserData === null || oldUserData.userId !== userData.userId) && userData && userData.credits.total > 0) {
      setOnCredits();
    }
  };

  handlePaymentSelection = (value) => {
    const { toggleCredits, handleCardSelect, userData,
      guests,
      maxGuests,
      dateOfBooking,
      changeCheckinDateBool,
      changeCheckinDateDif,
      changeCheckinDateTax,
      setOffCredits,
      price,
      type,
      isCreditsUsed,
      tax,
      promo } = this.props;

    let isCreditsEnough = false;

    if (userData && userData.subscription) {

      const { last24freeDayPass } = userData;
      const productAmount = Math.ceil(guests / maxGuests);

      const amountAfterSubCheck = (!last24freeDayPass && userData.subscription && !objectIsEmpty(userData.subscription) && moment(dateOfBooking).isBefore(moment().add(1, 'day')) && type === 0) ? (productAmount - 1) : productAmount;
      const countedPrice =  changeCheckinDateBool ? (changeCheckinDateDif+changeCheckinDateTax) : (amountAfterSubCheck * price + tax);
      const priceAfterPromo = promo.status === 'success' && !changeCheckinDateBool ? this.calculateTotalWithPromo(countedPrice) : countedPrice;

      const totalCredits = userData.credits.total;
      isCreditsEnough = totalCredits >= priceAfterPromo;
    }

    if(value.value === 'credits') {
      toggleCredits();
    } else if (value.value !== 'credits' && isCreditsEnough && isCreditsUsed) {
      setOffCredits();
      handleCardSelect(value);
    } else {
      handleCardSelect(value);
    };
  };

  calculateTotalWithPromo = (countedPrice) => {
    const {
      promo: {
        info: {
          type: promoType,
          amount: promoAmount,
        }
      }
    } = this.props;


    switch (Number(promoType)) {
      case 0:
        return (countedPrice * ((100 - promoAmount) / 100)).toFixed(2);
      case 1:
        return countedPrice - promoAmount >= 0 ? (countedPrice - promoAmount).toFixed(2) : 0;
      default:
        return countedPrice.toFixed(2);
    }
  };

  render() {
    const { handlePaymentSelection } = this;
    const { 
      promo, 
      cardsData, 
      payingWith, 
      style, 
      cardOnly,
       price, 
       userData, 
       maxGuests, 
       guests, 
       usingCredits, 
       type, 
       tax, 
       noCredits, 
       userPreferencesDate, 
       changeCheckinDateBool, 
       changeCheckinDate, 
       changeCheckinDateDif, 
       changeCheckinDateTax, 
       serviceFee,
      } = this.props;
    const newPaymentOptions = cardsData[1].options.filter(option => option.value !== 'paypal');

    const withoutCard = [
      {
        ...cardsData[1],
        options: newPaymentOptions,
      }
    ];

    let withoutCredit = [
      {
        ...cardsData[1],
      },
      {
        ...cardsData[2],
      }
    ];
    withoutCredit = withoutCredit.filter(ob => !objectIsEmpty(ob))
    let totalCredits = 0;
    let yourCreditsToPay = 0;
    let isCreditsEnough = null;
    // change UI part of card selection if user has some credit cards
    // TODO REDO ACCORDING TO SITUATION WHEN NEED TO ADD PAYMENT METHOD
    // CURRENT WAY IS +1 TO ARRAY ELEMENT NUMBER EVERY TIME WE ADD PAYMENT METHOD
    if (cardsData[2]) {
      withoutCard.push(cardsData[2]);
    }
    const dateOfBooking = changeCheckinDateBool ? changeCheckinDate : userPreferencesDate;
    
    if (userData && userData.credits.total > 0) {
      
      const { last24freeDayPass } = userData;
      const productAmount = Math.ceil(guests / maxGuests);

      const amountAfterSubCheck = (!last24freeDayPass && userData.subscription && !objectIsEmpty(userData.subscription) && moment(dateOfBooking).isBefore(moment().add(1, 'day')) && type === 0) ? (productAmount - 1) : productAmount;
      const countedPrice =  changeCheckinDateBool ? (changeCheckinDateDif+changeCheckinDateTax) : (amountAfterSubCheck * (price + tax));
      // first point
      const priceAfterPromo = promo.status === 'success' && !changeCheckinDateBool ? this.calculateTotalWithPromo(countedPrice) + (Number(serviceFee) || 0) : countedPrice + (Number(serviceFee) || 0);
      totalCredits = userData.credits.total;
      
      isCreditsEnough = totalCredits >= priceAfterPromo + (Number(serviceFee) || 0);
      yourCreditsToPay = isCreditsEnough ? Number(priceAfterPromo) : totalCredits;
      cardsData[0].options[0].label =`Use $${yourCreditsToPay.toFixed(2)} of your $${totalCredits.toFixed(2)} credit`;
    }

    return (
      <CardContainer style={style}>
        <Select
          name="card"
          className="card-select"
          classNamePrefix="card-select"
          placeholder="Select card"
          onChange={handlePaymentSelection}
          options={cardOnly ? withoutCard : userData && totalCredits !== 0 && !noCredits ? cardsData : withoutCredit}
          value={payingWith}
          cardOnly={cardOnly}
          price={price}
          yourCreditsToPay={yourCreditsToPay}
          maxGuests={maxGuests}
          guests={guests}
          usingCredits={usingCredits}
          userData={userData}
          noCredits={noCredits}
          isCreditsEnough={isCreditsEnough}
          blurInputOnSelect
          isSearchable={false}
          components={{ Option: getCustomOption, DropdownIndicator, SingleValue }}
        />
      </CardContainer>
    )
  }
}

export default CardSelect;
